import HttpService from '@/services/http/http.service';

export default class AdminEnrolmentService {
	constructor() {
		this.http = new HttpService();
	}

	create(enrolment) {
		return this.http.post('admin/enrolment', enrolment);
	}

	update(enrolment) {
		return this.http.put(`admin/enrolment/${enrolment.id}`, enrolment);
	}

	get(enrolmentId) {
		return this.http.get(`admin/enrolment/${enrolmentId}`);
	}

	remove(enrolmentId) {
		return this.http.delete(`admin/enrolment/${enrolmentId}`);
	}
}
